var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    {
      attrs: {
        id: "cancel-booking-modal",
        action: "Delete Appointment",
        title: "Are you sure?",
        subheading: _vm.subheadingText,
        actionColor: "danger",
        "secondary-action": "Cancel",
        secondaryActionColor: "black",
        loading: _vm.loading,
        hideClose: ""
      },
      on: {
        close: _vm.closeModal,
        cta: _vm.cancelBooking,
        "secondary-cta": _vm.closeModal
      }
    },
    [
      _vm.loading
        ? _c("div", [_c("div", { staticClass: "importing-animation" })])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }